import {
  CLEAR_PANEL_LAYOUT,
  LOCK_PANEL_LAYOUT_CONFIG,
  MOUNT_RIGHT_PANEL,
  SET_PANEL_LAYOUT_CONFIG,
  UNLOCK_PANEL_LAYOUT_CONFIG,
} from '../actions/PanelLayoutActions';
import { PANEL_CONFIGURATIONS } from '../constants/PanelLayoutConstants';

const initialState = {
  config: PANEL_CONFIGURATIONS.ONLY_MIDDLE,
  configLocked: true,
  isRightPanelMounted: false,
};

export default function panelLayoutReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PANEL_LAYOUT_CONFIG:
      return {
        ...state,
        config: action.config,
      };

    case LOCK_PANEL_LAYOUT_CONFIG:
      return {
        ...state,
        configLocked: true,
      };

    case UNLOCK_PANEL_LAYOUT_CONFIG:
      return {
        ...state,
        configLocked: false,
      };

    case MOUNT_RIGHT_PANEL:
      return {
        ...state,
        isRightPanelMounted: true,
      };

    case CLEAR_PANEL_LAYOUT: {
      return initialState;
    }

    default:
      return state;
  }
}
